;(function () {
  function initSlider(section) {
    if (section.dataset.sliderInitialized === 'true') {
      return
    }

    const container = section.querySelector('[data-popular-swiper]')
    const prev = section.querySelector('[data-popular-prev]')
    const next = section.querySelector('[data-popular-next]')
    const scrollbar = section.querySelector('[data-popular-scrollbar]')
    const controls = section.querySelector('.popular-products__controls')

    if (!container) {
      console.warn('Popular products carousel: Container not found')
      return
    }

    if (typeof Swiper === 'undefined') {
      console.warn('Popular products carousel: Swiper not loaded')
      return
    }

    console.log('Initializing popular products carousel')

    const swiper = new Swiper(container, {
      slidesPerView: 2,
      spaceBetween: 12,
      freeMode: false,
      navigation: {
        nextEl: next,
        prevEl: prev
      },
      scrollbar: {
        el: scrollbar,
        draggable: true
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 16
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 18
        },
        990: {
          slidesPerView: 4,
          spaceBetween: 20
        }
      },
      on: {
        init: function () {
          updateNavigationVisibility(this, controls)
        },
        resize: function () {
          updateNavigationVisibility(this, controls)
        }
      }
    })

    section.dataset.sliderInitialized = 'true'
  }

  function updateNavigationVisibility(swiper, controls) {
    if (!controls) return

    const totalSlides = swiper.slides.length
    const slidesPerView = swiper.params.slidesPerView

    // Show arrows only if there are more slides than visible
    if (totalSlides > slidesPerView) {
      controls.style.display = 'flex'
    } else {
      controls.style.display = 'none'
    }
  }

  function init(section) {
    if (!section) {
      return
    }

    // Check if there are products to display
    const swiperWrapper = section.querySelector('.swiper-wrapper')
    if (!swiperWrapper || swiperWrapper.children.length === 0) {
      console.log('No products found in carousel')
      return
    }

    console.log('Found products, initializing carousel')
    initSlider(section)
  }

  function onSectionLoad(event) {
    const sections = event.target.querySelectorAll('[data-section-type="popular-products"]')
    sections.forEach(init)
  }

  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('[data-section-type="popular-products"]')
    sections.forEach(init)
  })

  document.addEventListener('shopify:section:load', onSectionLoad)
})()
